import { gql } from '@/__generated__';

export const commentListDocument = gql(/* GraphQL */ `
  query CommentList(
    $where: CommentWhereInput
    $orderBy: [CommentOrderByWithRelationInput!]
    $skip: Int
    $take: Int
  ) {
    comments(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
      id
      commentId
      body
      postId
      createdAt
      customer {
        id
        name
        email
        avatar
        createdAt
        _count {
          orders
        }
        addresses(orderBy: { createdAt: desc }, take: 1) {
          country
          postCode
        }
      }
    }
  }
`);

export const commentsListPageDocument = gql(/* GraphQL */ `
  query CommentsListPage(
    $where: CommentWhereInput
    $orderBy: [CommentOrderByWithRelationInput!]
    $skip: Int
    $take: Int
  ) {
    commentsListPage(where: $where, orderBy: $orderBy, skip: $skip, take: $take) {
      totalCount
      items {
        id
        commentId
        body
        postId
        createdAt
        customer {
          id
          name
          email
          avatar
          createdAt
          _count {
            orders
          }
          addresses(orderBy: { createdAt: desc }, take: 1) {
            country
            postCode
          }
        }
      }
    }
  }
`);

export const commentsByLastKrajPageDocument = gql(/* GraphQL */ `
  query CommentsByLastKrajPage(
    $where: CommentWhereInput
    $skip: Int
    $take: Int
    $direction: SortOrder
    $filterKraj: String
    $sortByKraj: Boolean
  ) {
    commentsByLastKrajPage(
      where: $where
      skip: $skip
      take: $take
      direction: $direction
      filterKraj: $filterKraj
      sortByKraj: $sortByKraj
    ) {
      totalCount
      items {
        id
        commentId
        body
        postId
        createdAt
        customer {
          id
          name
          email
          avatar
          createdAt
          _count {
            orders
          }
          addresses(orderBy: { createdAt: desc }, take: 1) {
            country
            postCode
          }
        }
      }
    }
  }
`);

export const countCommentsDocument = gql(/* GraphQL */ `
  query CountComments($where: CommentWhereInput!) {
    countComments(where: $where)
  }
`);
